import React from "react";
import { Toaster } from "./ui/sonner";
import { MarketingFooter, MarketingHeader } from "./MarketingChrome";
import { Bim4DContactSection } from "./bim4d/Bim4DContactSection";
import { Bim4DEstimatorSection } from "./bim4d/Bim4DEstimatorSection";
import { Bim4DHeroSection } from "./bim4d/Bim4DHeroSection";

export default function Bim4DPlanningPage() {
  return (
    <div className="relative overflow-hidden bg-[radial-gradient(circle_at_top,_rgba(190,242,100,0.14),_transparent_24%),linear-gradient(180deg,_#fbfdf8_0%,_#f8fcf3_44%,_#ffffff_100%)]" data-testid="bim4d-page">
      <MarketingHeader />
      <main>
        <Bim4DHeroSection />
        <Bim4DEstimatorSection />
        <Bim4DContactSection />
      </main>
      <MarketingFooter />
      <Toaster closeButton position="top-center" />
    </div>
  );
}